var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('Row',[_c('Column',{attrs:{"width":15}},[_c('iframe',{attrs:{"src":_vm.rowData.pdfUrl(),"width":"100%","height":"1000px"}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }